const REPROCESSOR_EVENTS = [
  'cocoon:after-insert'
]

REPROCESSOR_EVENTS.forEach((event) => {
  document.addEventListener(event, (evt) => {
    htmx.process(document.body)
  })
})
